import React from 'react'
import { useTranslation } from 'react-i18next'

import IconRefresh from '../../assets/icons/refresh-small.svg'
import Button from '../Button'
import Cta from '../Cta'
import { customCtaCard } from '../../style'

const SwapButton = ({ onRefresh, dataTestId, text }) => {
  const { i18n } = useTranslation()
  const isGerman = i18n.language === 'de_DE'
  return (
    <Button
      onClick={() => {
        onRefresh()
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '12px',
      }}
      data-testid={dataTestId}
    >
      <img src={IconRefresh} alt="" />
      <Cta text={text} customStyle={customCtaCard} isGerman={isGerman} />
    </Button>
  )
}

export default SwapButton
